import { createContext, useContext } from 'react';

// Create a typed context (replace `unknown` with actual value if needed)
export const ApiInterceptorContext = createContext<Record<string, never>>({});

export const useApiInterceptor = () => useContext(ApiInterceptorContext);
